import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { BankIdLogo } from "@/components/bank-id/utilities/bank-id-logo";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslations } from "@/hooks/use-translations";

export const BankIdDialogHeaderElements = () => {
  const { __ } = useTranslations();

  return (
    <DialogHeader className={"grid-cols-4"}>
      <DialogTitle className={"col-span-3"}>
        <div className="flex w-full items-center">
          <BankIdLogo />
          <span className={"ml-4"}>{__("bank_id.identify_with_bank_id")}</span>
        </div>
      </DialogTitle>
    </DialogHeader>
  );
};

export const VisuallyHiddenBankIdDialogHeaderElements = () => (
  <VisuallyHidden>
    <BankIdDialogHeaderElements />
  </VisuallyHidden>
);
